import {
  takeEvery, put, debounce, select,
} from 'redux-saga/effects';

import { makeGetRequest } from 'tools/utilities/ajax';
import { AddressPrediction, AddressDetails } from 'types';
import {
  TYPES, ILookupSuccess, ILookupFailure, ILookup, IDetails, IDetailsSuccess, IDetailsFailure,
} from './actions';
// eslint-disable-next-line import/no-cycle
import { getBearerToken } from '../utils/getBearerToken';

const googleApiUrl: string = process.env.REACT_APP_GOOGLE_API_URL;
const googlePlacesApiKey: string = process.env.REACT_APP_GOOGLE_PLACES_API_KEY;
const GOOGLE_PLACES_SEARCH_API_URL = `/maps/api/place/autocomplete/json?types=address&components=country:nz&key=${googlePlacesApiKey}`;
const GOOGLE_PLACES_DETAILS_API_URL = `/maps/api/place/details/json?types=address&?fields=place_id&key=${googlePlacesApiKey}`;

interface IAddressLookupResults {
  predictions: AddressPrediction[];
  status: string; // 'OK'
}

interface IDetailsLookupResults {
  result: AddressDetails;
  status: string; // 'OK'
}

function* fetchAddressResults(action: ILookup) {
  const {
    searchTerm,
  } = action.payload;

  try {
    const bearerToken: string = yield select(getBearerToken);
    const response: IAddressLookupResults = yield makeGetRequest<IAddressLookupResults>(`${GOOGLE_PLACES_SEARCH_API_URL}`, { input: searchTerm }, bearerToken, googleApiUrl);
    const addressResults = response.predictions;

    yield put<ILookupSuccess>({
      type: TYPES.LOOKUP_SUCCESS,
      payload: {
        addressResults,
      },
    });
  } catch (error) {
    console.error('error', error);

    yield put<ILookupFailure>({
      type: TYPES.LOOKUP_FAILURE,
      payload: {
        error: 'Something went wrong.',
      },
    });
  }
}

function* fetchAddressDetails(action: IDetails) {
  const {
    placeId,
  } = action.payload;

  try {
    const bearerToken: string = yield select(getBearerToken);
    const response: IDetailsLookupResults = yield makeGetRequest<IDetailsLookupResults>(`${GOOGLE_PLACES_DETAILS_API_URL}`, { place_id: placeId }, bearerToken, googleApiUrl);

    yield put<IDetailsSuccess>({
      type: TYPES.DETAILS_SUCCESS,
      payload: {
        details: response.result,
      },
    });
  } catch (error) {
    console.error('error', error);

    yield put<IDetailsFailure>({
      type: TYPES.DETAILS_FAILURE,
      payload: {
        error: 'Something went wrong.',
      },
    });
  }
}

export function* addressLookupSaga() {
  yield debounce(250, TYPES.LOOKUP, fetchAddressResults);
  yield takeEvery(TYPES.DETAILS, fetchAddressDetails);
}
